function getParamFallback(name) {
  const formatted = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');

  const regex = new RegExp('[\\?&]' + formatted + '=?([^&#]*)');
  const results = regex.exec(window.location.search);

  if (results === null) {
    return null;
  }

  if (results && !results[1]) {
    return '';
  }

  return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getUrlParameter(name) {
  if (!window.URLSearchParams) {
    return getParamFallback(name);
  }

  return new URLSearchParams(window.location.search).get(name);
}
